import advertisement from "./advertisement";
import player from "./player";
import queue from "./queue";
import recommended from "./recommended";
import streams from "./streams";

const state = {
  activated: false,
  open: false,
  activeTab: "queue",
  tick: Date.now(),
  player,
  queue,
  recommended,
  streams,
  advertisement
};

export default state;
